import { Grid, Typography } from "@mui/material";
import { BlFormInput } from "Forms/Components/BlFormInput";
import type { InvestmentsFormType } from "Forms/Schemas/GoalsFulfillment/CurrentSolution/investmentsFormSchema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { assetAllocationFields } from "./CharacteristicsAccordion";

const assetAllocationMask = [
  {
    mask: Number,
    thousandsSeparator: " ",
    scale: 0,
  },
];

export const AssetAllocationFields = () => {
  const { t } = useResource();
  const {
    watch,
    trigger,
    formState: { errors },
    control,
    setValue,
  } = useFormContext<InvestmentsFormType>();

  useEffect(() => {
    const subscription = watch((values, { name }) => {
      if (name && assetAllocationFields.includes(name as any)) {
        for (const field of assetAllocationFields) {
          const value = values[field];

          if ((value as unknown) === "" || value === null || value === undefined) {
            setValue(field, 0, { shouldValidate: false });
          }
        }

        trigger(assetAllocationFields);
      }
    });

    return () => subscription.unsubscribe();
  }, [watch, trigger, setValue]);

  return (
    <Grid container spacing={Spacing.XL} mt={Spacing.XL}>
      <Grid size={8}>
        <BlFormInput
          control={control}
          name="equitiesName"
          errors={errors}
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.Equities)}
          disabled
        />
      </Grid>
      <Grid size={4}>
        <BlFormInput
          control={control}
          name="equities"
          errors={errors}
          inputEndAdornment={
            <Typography variant="body2" color="secondary">
              %
            </Typography>
          }
          placeholder="0"
          unmask="typed"
          mask={assetAllocationMask}
        />
      </Grid>

      <Grid size={8}>
        <BlFormInput
          control={control}
          name="bondsName"
          errors={errors}
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.Bonds)}
          disabled
        />
      </Grid>
      <Grid size={4}>
        <BlFormInput
          control={control}
          name="bonds"
          errors={errors}
          inputEndAdornment={
            <Typography variant="body2" color="secondary">
              %
            </Typography>
          }
          placeholder="0"
          unmask="typed"
          mask={assetAllocationMask}
        />
      </Grid>

      <Grid size={8}>
        <BlFormInput
          control={control}
          name="commoditiesName"
          errors={errors}
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.Commodities)}
          disabled
        />
      </Grid>
      <Grid size={4}>
        <BlFormInput
          control={control}
          name="commodities"
          errors={errors}
          inputEndAdornment={
            <Typography variant="body2" color="secondary">
              %
            </Typography>
          }
          placeholder="0"
          unmask="typed"
          mask={assetAllocationMask}
        />
      </Grid>

      <Grid size={8}>
        <BlFormInput
          control={control}
          name="realEstateName"
          errors={errors}
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.RealEstate)}
          disabled
        />
      </Grid>
      <Grid size={4}>
        <BlFormInput
          control={control}
          name="realEstate"
          errors={errors}
          inputEndAdornment={
            <Typography variant="body2" color="secondary">
              %
            </Typography>
          }
          placeholder="0"
          unmask="typed"
          mask={assetAllocationMask}
        />
      </Grid>

      <Grid size={8}>
        <BlFormInput
          control={control}
          name="cashName"
          errors={errors}
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.Cash)}
          disabled
        />
      </Grid>
      <Grid size={4}>
        <BlFormInput
          control={control}
          name="cash"
          errors={errors}
          inputEndAdornment={
            <Typography variant="body2" color="secondary">
              %
            </Typography>
          }
          placeholder="0"
          unmask="typed"
          mask={assetAllocationMask}
        />
      </Grid>

      <Grid size={8}>
        <BlFormInput
          control={control}
          name="otherName"
          errors={errors}
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.Other)}
          disabled
        />
      </Grid>
      <Grid size={4}>
        <BlFormInput
          control={control}
          name="other"
          errors={errors}
          inputEndAdornment={
            <Typography variant="body2" color="secondary">
              %
            </Typography>
          }
          placeholder="0"
          unmask="typed"
          mask={assetAllocationMask}
        />
      </Grid>
    </Grid>
  );
};
